import { Navigate } from "react-router-dom";
import { useCartContext } from "@/src/context/CartContext";
import { CheckoutForm } from "./(sections)/CheckoutForm";
import { OrderSummary } from "./(sections)/OrderSummary";

export function CheckoutPage() {
    const { cart } = useCartContext();

    if (cart.length === 0) return <Navigate to="/collection" replace />;

    return (
        <div className="min-h-screen pt-40 pb-24">
            <div className="max-w-7xl mx-auto px-6">
                <div className="mb-12">
                    <p className="uppercase tracking-[0.3em] text-sm text-stone-400 mb-4 font-light">
                        Secure checkout
                    </p>
                    <h1 className="font-serif text-5xl md:text-7xl font-light italic">Checkout</h1>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-16 items-start">
                    <div className="lg:col-span-2">
                        <CheckoutForm />
                    </div>
                    <OrderSummary />
                </div>
            </div>
        </div>
    );
}
